import { CustomerProfileResourceTypeMappings } from '@aa/nest/resource';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, mergeMap, of, switchMap, take, tap } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { CustomerProfileService } from '../../services/customer-profile.service';
import { UserService } from '../../services/user.service';
import { BaseResourceEffects } from '../base-resource.effects';
import { CoreAppState } from '../core-app.state';
import { userActions } from '../user/user.actions';
import { customerProfileActions } from './customer-profile.actions';
import { selectCustomerProfileState } from './customer-profile.reducer';

// @aa:gen-ignore

@Injectable()
export class CustomerProfileEffects extends BaseResourceEffects<CustomerProfileResourceTypeMappings> {
  updateItemWithUserAccount$ = createEffect(() =>
    this.actions$.pipe(
      ofType(customerProfileActions.updateCustomerProfileWithUserAccount),
      mergeMap((payload) =>
        this.store
          .select((s) => this.stateSelector(s).currentQuery)
          .pipe(
            take(1),
            tap((r) => console.log(payload)),
            switchMap((currentQuery) =>
              this.service
                .update(payload.id, {
                  ...payload.data,
                  email: undefined,
                  userId: undefined,
                } as any)
                .pipe(
                  switchMap(() =>
                    this.userService
                      .update(payload.data.userId!, {
                        email: payload.data.email,
                      })
                      .pipe(
                        switchMap(() =>
                          (payload.andRefresh
                            ? this.authService.refresh()
                            : of(null)
                          ).pipe(
                            map(() =>
                              this.itemActions.loadItems({
                                query: (currentQuery ?? {}) as any,
                              }),
                            ),
                          ),
                        ),
                      ),
                  ),
                  catchError((err) =>
                    of(
                      this.itemActions.setError({
                        error:
                          err.error?.message?.toString() ??
                          err.message?.toString() ??
                          err.toString(),
                      }),
                    ),
                  ),
                ),
            ),
          ),
      ),
    ),
  );

  constructor(
    protected override readonly actions$: Actions,
    protected override readonly store: Store<CoreAppState>,
    protected override readonly service: CustomerProfileService,
    private readonly authService: AuthService,
    private readonly userService: UserService,
  ) {
    super(
      actions$,
      store,
      service,
      customerProfileActions,
      selectCustomerProfileState,
      [userActions.setItems],
    );
  }
}
